import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { BannerMobile } from './BannerMobile'

import { BannerInfoProps } from './types'
import * as Styles from './styles'

export const BannerInfo = ({ theme = 'career_coaching', items }: BannerInfoProps) => {
  const { isPhone } = useMediaQueries()

  if (isPhone) {
    return <BannerMobile theme={theme} items={items} />
  }

  return (
    <Styles.Container theme={theme}>
      {items.map((item, index) => (
        <Styles.Item key={index}>
          <Styles.Icon />
          <Styles.Title dangerouslySetInnerHTML={{ __html: item }} />
        </Styles.Item>
      ))}
    </Styles.Container>
  )
}
